import { FETCH_SETTINGS, UPDATE_SETTINGS } from "../../actions/actionTypes";

const settingsReducer = (state={}, action) => {
    let settings = state;
    if(action && action.payload && !action.payload.errors){
        switch(action.type){
            case FETCH_SETTINGS:
                return action.payload.settings || settings;
            case UPDATE_SETTINGS:
                return action.payload.settings || settings;
        }
    }
    return settings;
}

export default settingsReducer;